import React from "react"

const debug = false
// const debug = "DocumentsViewSettingsMenuOptions"

type Props = {
    label?          : string
    component?      : any
}

export default function PopoverMenu_OptionSettings(props:Props) {



    return (
        <div className="option fl-jsb">
            <div className="label">{props.label}</div>
            {props.component}
            {/*<FormToggle size="18"*/}
            {/*            value={!!props.menuParams.module.filters.preFilters['projectId']}*/}
            {/*            onChange={onToggleSubFolders}/>*/}

        </div>
    )
}